var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"irr-calc-link",attrs:{"role":"link","tabindex":"0"},on:{"click":_vm.open,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.open.apply(null, arguments)}}},[_vm._v(">> 进一步计算对应 IRR")])
}
var staticRenderFns = []

export { render, staticRenderFns }